import type { V2InheritedDef, V2LabelDef, V2UnitDef } from "../types";

/**
 * Merge two inherited definitions with child values overriding parent.
 * @param parent - Parent inherited definition
 * @param child - Child inherited definition
 * @returns Merged inherited definition
 */
export function mergeInherited(
  parent: V2InheritedDef,
  child: V2InheritedDef | undefined,
): V2InheritedDef {
  if (!child) return parent;
  return {
    label: child.label ? { ...parent.label, ...child.label } : parent.label,
    unit: child.unit ? { ...parent.unit, ...child.unit } : parent.unit,
    text: child.text ? { ...parent.text, ...child.text } : parent.text,
  };
}

/**
 * Resolve effective label by merging inherited and item-level overrides.
 * @param itemLabel - Item-level label overrides
 * @param inheritedLabel - Inherited label defaults
 * @returns Resolved label definition
 */
export function resolveLabel(
  itemLabel: V2LabelDef | undefined,
  inheritedLabel: Partial<V2LabelDef> | undefined,
): V2LabelDef {
  return { ...inheritedLabel, ...itemLabel };
}

/**
 * Resolve effective unit by merging inherited and item-level overrides.
 * @param itemUnit - Item-level unit overrides
 * @param inheritedUnit - Inherited unit defaults
 * @returns Resolved unit definition
 */
export function resolveUnit(
  itemUnit: V2UnitDef | undefined,
  inheritedUnit: Partial<V2UnitDef> | undefined,
): V2UnitDef {
  const merged: V2UnitDef = { ...inheritedUnit, ...itemUnit };
  return merged;
}
